import React from 'react';

export const Text = ({ type, info, classes, handleClose, handleSeeComment }) => {
    // const router = useNavigate();

    // const handleGetLink = () => {
    //     router(`/organization/${info.org.id}`);
    //     handleClose();
    // };

    return (
        <p>
            {
                type === 'EVENT_APPROVED' ? (
                    <span>
                        Your event
                        <a className={classes.linkButton} href={`/event/${info.event.eventId}`} target={'_blank'}
                           rel="noreferrer">
                            {info && info.event && info.event.eventName}
                        </a>
                        was approved
                    </span>
                ) : type === 'EVENT_DISAPPROVED' ? (
                    <span>
                        Your event has been disapproved.
                        <span
                            style={{ cursor: 'pointer' }}
                            onClick={() => (info.event && info.event.eventId ? handleSeeComment(info.event.eventId) : '')}>
                            &nbsp;See the comment
                        </span>
                    </span>
                ) : type === 'CLAIM_APPORVED' ? (
                    <span>
                       Your claim to

                        <a className={classes.linkButton} href={`/organization/${info.org.id}`} target={'_blank'} rel="noreferrer">
                            {type === 'CLAIM_APPORVED' ? info?.org && info?.org?.name : ''}
                        </a>
                        was approved. If you believe this is an error, feel free to contact us.”
                    </span>
                ) : type === 'CLAIM_REJECTED' ? (
                    <span>
                     Your claim to
                        <a className={classes.linkButton} href={`/organization/${info.org.id}`} target={'_blank'} rel="noreferrer">
                          {type === 'CLAIM_REJECTED' ? info?.org && info?.org?.name : ''}
                        </a>
                        wasn’t approved. If you believe this is an error, feel free to contact us.”
                    </span>
                ) : type === 'UPGRADE_VERIFITED' ? (
                    `${info.inviter}  invites you to become a Verified Member to create events and invite people`
                ) : type === 'DOWNGRADE_MEMBER' ? (
                    `You have become an Unverified Member. Now you cannot create events and invite people`
                ) : type === 'UPGRADE_ORGANIZER' ? (
                    `Congrats! You have become an Organizer. Now you can create & publish events and invite people`
                ) : type === 'UPGRADE_ORGANIZATION_ADMIN' ? (
                    'Congrats! You have become an Organization Admin'
                ) : type === 'UPGRADE_ORGANIZATION_ORGANIZER' ? (
                    'Congrats! You have become an Organization Organizer'
                ) : type === 'DOWNGRADE_ORGANIZATION_MANAGER' ? (
                    'You have become an Organization Manager'
                ) : type === 'DOWNGRADE_ORGANIZATION_MEMBER' ? (
                    'You have become an Organization Member'
                ) : type === 'UPGRADE_ORGANIZATION_MEMBER' ? (
                    'Congrats! You have become an Organization Member'
                ) : type === 'UPGRADE_ORGANIZATION_MANAGER' ? (
                    'Congrats! You have become an Organization Manager'
                ) : (
                    ''
                )

                // You have become an Unverified Member.
            }
        </p>
    );
};
